import { Link } from 'react-router-dom';
import { useLanguage } from '../../core/hooks/use-language';
import { useTranslation } from '../../core/hooks/use-translation';

/**
 * The rule under the documents — the site footer's gradient with only its bottom row, which is what
 * the live legal page carries.
 *
 * Both links point at this page, because both documents are on it. The live page points them at
 * `legal.html`, a file that does not exist on the server: the copyright line at the bottom of the
 * privacy policy is two dead links.
 */
export function PolicyFooter() {
    const { t } = useTranslation();
    const language = useLanguage();

    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-bottom">
                    <p className="footer-copy">
                        {t('site.footer.copy').replace('{year}', String(new Date().getFullYear()))}{' '}
                        <Link to={`/${language}/policy`}>{t('site.footer.policy')}</Link> ·{' '}
                        <Link to={`/${language}/policy`}>{t('site.footer.terms')}</Link>
                    </p>
                    <p className="footer-tagline">{t('site.footer.tagline')}</p>
                </div>
            </div>
        </footer>
    );
}
